<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("F&B Refund Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getFnbRefundReport('N', 'N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="fnbRefundRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getFnbRefundReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getFnbRefundReport('N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>ORIGINAL TRANSACTION DATE</th>
            <th>ORIGINAL CONFIRMATION CODE NO</th>
            <th>ITEM</th>
            <th>FOOD PICK UP</th>
            <th>QUANTITY</th>
            <th>SELLING PRICE ( RATE)</th>
            <th>GROSS AMOUNT</th>
            <th>DISCOUNT</th>
            <th>PAYMENT MODE</th>
            <th>REFUNDED AMOUNT</th>
            <th>REFUND DATE</th>
            <th>REFUND TIME</th>
            <th>REFUND PAYMENT MODE</th>
            <th>REFUNDED BY</th>
            <th>APPROVER</th>
            <th>COMMENTS</th>
          </thead>
          <tbody v-if="recordsWithTotals.length > 0">
            <tr
              v-for="(data, Index) in recordsWithTotals"
              :key="Index"
              :class="{ 'total-row': data.isTotalRow }"
            >
              <td class="text-left">
                {{
                  data.original_transaction_date
                  
                }}
              </td>
              <td class="text-right">
                <template v-if="data.isTotalRow">
                  <strong>Total:</strong>
                </template>
                {{ data.original_confirmation_code }}
              </td>
              <td class="text-left">{{ data.item_name }}</td>
              <td class="text-left">{{ data.isPickup }}</td>
              <td class="text-right">{{ data.quantity }}</td>
              <td class="text-right">
                <template v-if="data.isTotalRow"
                  ><strong>{{
                    currFormat(data.selling_price_total)
                  }}</strong></template
                >
                {{ data.selling_price }}
              </td>
              <td class="text-right">
                <template v-if="data.isTotalRow"
                  ><strong>{{
                    currFormat(data.gross_amount_total)
                  }}</strong></template
                >
                {{ data.gross_amount }}
              </td>
              <td class="text-right">{{ data.discount }}</td>
              <td class="text-left">{{ data.payment_mode }}</td>
              <td class="text-right">
                <template v-if="data.isTotalRow"
                  ><strong>{{
                    currFormat(data.refunded_amount_total)
                  }}</strong></template
                >
                {{ data.refunded_amount }}
              </td>
              <td class="text-center">
                {{
                  data.refund_datetime
                    ? moment(data.refund_datetime).format("YYYY-MM-DD")
                    : "-"
                }}
              </td>
              <td class="text-center">
                {{
                  data.refund_datetime
                    ? moment(data.refund_datetime).format("HH:mm")
                    : "-"
                }}
              </td>
              <td class="text-left">{{ data.refund_payment_mode }}</td>
              <td class="text-left">{{ data.refunded_by }}</td>
              <td class="text-left">
                <template v-if="!data.isTotalRow">{{
                  data.refund_approved_by ? data.refund_approved_by : "-"
                }}</template>
              </td>
              <td class="text-left">{{ data.refund_reason }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="16">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        fnbRefundRecords: [],
        excelFilePath: "",
        grandTotal: {},
        totalsByCode: {},
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      const { cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id);
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
    },
    // computed: {
    //   recordsWithTotals() {
    //     const recordsWithTotals = [];
    //     let currentCode = null;
    //     let currentSellingPriceTotal = 0;
    //     let currentGrossAmountTotal = 0;
    //     let currentRefundedAmountTotal = 0;

    //     for (const record of this.fnbRefundRecords) {
    //       if (record.original_confirmation_code === currentCode) {
    //         currentSellingPriceTotal += parseFloat(record.selling_price) || 0;
    //         currentGrossAmountTotal += parseFloat(record.gross_amount) || 0;
    //         currentRefundedAmountTotal += parseFloat(record.refunded_amount) || 0;
    //       } else {
    //         if (currentCode !== null) {
    //           recordsWithTotals.push({
    //             isTotalRow: true,
    //             selling_price_total: currentSellingPriceTotal,
    //             gross_amount_total: currentGrossAmountTotal,
    //             refunded_amount_total: currentRefundedAmountTotal,
    //           });
    //         }
    //         currentCode = record.original_confirmation_code;
    //         currentSellingPriceTotal = parseFloat(record.selling_price) || 0;
    //         currentGrossAmountTotal = parseFloat(record.gross_amount) || 0;
    //         currentRefundedAmountTotal = parseFloat(record.refunded_amount) || 0;
    //       }
    //       recordsWithTotals.push(record);
    //     }

    //     if (currentCode !== null) {
    //       recordsWithTotals.push({
    //         isTotalRow: true,
    //         selling_price_total: currentSellingPriceTotal,
    //         gross_amount_total: currentGrossAmountTotal,
    //         refunded_amount_total: currentRefundedAmountTotal,
    //       });
    //     }
    //     console.log(recordsWithTotals);
    //     return recordsWithTotals;
    //   },
    // },

    computed: {
      recordsWithTotals() {
        const recordsWithTotals = [];
        let currentCode = null;
        let currentSellingPriceTotal = 0;
        let currentGrossAmountTotal = 0;
        let currentRefundedAmountTotal = 0;

        for (const record of this.fnbRefundRecords) {
          const formattedRecord = { ...record };

          if (record.original_confirmation_code === currentCode) {
            currentSellingPriceTotal += parseFloat(record.selling_price) || 0;
            currentGrossAmountTotal += parseFloat(record.gross_amount) || 0;
            currentRefundedAmountTotal +=
              parseFloat(record.refunded_amount) || 0;
          } else {
            if (currentCode !== null) {
              recordsWithTotals.push({
                isTotalRow: true,
                selling_price_total: currentSellingPriceTotal.toFixed(this.MIN_FRACTION_DIGITS),
                gross_amount_total: currentGrossAmountTotal.toFixed(this.MIN_FRACTION_DIGITS),
                refunded_amount_total: currentRefundedAmountTotal.toFixed(this.MIN_FRACTION_DIGITS),
              });
            }
            currentCode = record.original_confirmation_code;
            currentSellingPriceTotal = parseFloat(record.selling_price) || 0;
            currentGrossAmountTotal = parseFloat(record.gross_amount) || 0;
            currentRefundedAmountTotal =
              parseFloat(record.refunded_amount) || 0;
          }
          formattedRecord.selling_price = parseFloat(
            formattedRecord.selling_price
          ).toFixed(this.MIN_FRACTION_DIGITS);
          formattedRecord.gross_amount = parseFloat(
            formattedRecord.gross_amount
          ).toFixed(this.MIN_FRACTION_DIGITS);
          formattedRecord.refunded_amount = parseFloat(
            formattedRecord.refunded_amount
          ).toFixed(this.MIN_FRACTION_DIGITS);

          recordsWithTotals.push(formattedRecord);
        }

        if (currentCode !== null) {
          recordsWithTotals.push({
            isTotalRow: true,
            selling_price_total: currentSellingPriceTotal.toFixed(this.MIN_FRACTION_DIGITS),
            gross_amount_total: currentGrossAmountTotal.toFixed(this.MIN_FRACTION_DIGITS),
            refunded_amount_total: currentRefundedAmountTotal.toFixed(this.MIN_FRACTION_DIGITS),
          });
        }

        return recordsWithTotals;
      },
    },

    mounted() {},
    methods: {
      moment,
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: `RawMaterialSupplierWise`,
        });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn ||
                `RawMaterialSupplierWiseCost-${
                  this.dropDown.selectedCinemaName
                }.${type || "xlsx"}`
            );
      },
      getCinemaList: function(cinema_id) {
        MasterService.GetCinemas({cine_id: cinema_id})
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getFnbRefundReport(isExcel = "N", isPdf = "N") {
        this.fnbRefundRecords = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
        };
        ReportsService.GetFnbRefundReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.fnbRefundRecords = [...data.Records];
              // this.calculateTotalsByConfirmationCode();

              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      // calculateTotalsByConfirmationCode() {
      //   // Create an object to store totals by confirmation code
      //   const totalsByCode = {};

      //   // Iterate through the records and accumulate totals
      //   this.fnbRefundRecords.forEach((record) => {
      //     const code = record.original_confirmation_code;

      //     if (!totalsByCode[code]) {
      //       totalsByCode[code] = {
      //         sellingPriceTotal: 0,
      //         grossAmountTotal: 0,
      //         refundedAmountTotal: 0,
      //       };
      //     }

      //     totalsByCode[code].sellingPriceTotal +=
      //       parseFloat(record.selling_price) || 0;
      //     totalsByCode[code].grossAmountTotal +=
      //       parseFloat(record.gross_amount) || 0;
      //     totalsByCode[code].refundedAmountTotal +=
      //       parseFloat(record.refunded_amount) || 0;
      //   });

      //   // Now, you can store these totals and use them as needed
      //   this.totalsByCode = totalsByCode;
      // },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .no_border {
    border: 0px !important;
  }
  .total-row {
    background-color: lightgray;
  }
  .total-row td:not(.text-right) {
    border: none;
  }
</style>

<!-- <tbody v-if="fnbRefundRecords.length > 0">
            <tr v-for="(data, Index) in fnbRefundRecords" :key="Index">
              <td class="text-left">
                {{
                  moment(data.original_transaction_date).format("YYYY-MM-DD")
                }}
              </td>
              <td class="text-left">{{ data.original_confirmation_code }}</td>
              <td class="text-left">{{ data.item_name }}</td>
              <td class="text-left">{{ data.isPickup }}</td>
              <td class="text-left">{{ data.quantity }}</td>
              <td class="text-left">{{ currFormat(data.selling_price) }}</td>
              <td class="text-right">{{ currFormat(data.gross_amount) }}</td>
              <td class="text-left">{{ data.discount }}</td>
              <td class="text-left">{{ data.payment_mode }}</td>
              <td class="text-right">{{ currFormat(data.refunded_amount) }}</td>
              <td class="text-right">
                {{ moment(data.refund_datetime).format("YYYY-MM-DD") }}
              </td>
              <td class="text-right">
                {{ moment(data.refund_datetime).format("HH:mm") }}
              </td>
              <td class="text-right">{{ data.refund_payment_mode_id }}</td>
              <td class="text-left">{{ data.refunded_by }}</td>
              <td class="text-left">{{ "-" }}</td>
              <td class="text-left">{{ data.refund_reason }}</td>
            </tr> -->



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fnbRefundReport.vue